import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { Localized } from 'app/objects';
import { LectionaryItemEditComponent } from '../lectionary-item-edit/lectionary-item-edit.component';
import { LectionaryItem, LectionaryItemSummary, LectionaryItemService } from '../../services/lectionary-item.service';
import { LectionaryItemNameSummary } from '../../services/lectionary-item-name.service';
import { PaginationInstance } from 'ngx-pagination';
import { LectionaryItemSearchModel } from '../lectionary-item-search/lectionary-item-search.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lectionary-item',
  templateUrl: './lectionary-item.component.html',
  styleUrls: ['./lectionary-item.component.css']
})
export class LectionaryItemComponent implements OnInit {

  public entities: LectionaryItemSummary[];
  public isLoading = false;
  public searchName: string;
  public searchProofed: boolean;
  public searchStatus: boolean;

  public countTotalProofed: number; 
  public countTotalNotProofed: number; 

  private mostRecentLectionaryItemSearchModel: LectionaryItemSearchModel;

  private localStorageKey_numberOfRecords = "grid_numberOfItemsToDisplay_lectionaryItems";
  private localStorageKey_searchProofed = "search_lectionaryItems_proofed";
  private localStorageKey_searchStatus = "search_lectionaryItems_status";

  public numberOfRecords = 0;
  public pageNumber = 1;  
 
  constructor(
    public dialog: MatDialog,
    private lectionaryItemSvc: LectionaryItemService,
    private apiSvc: ApiService,
    private route: ActivatedRoute
  ) { }

ngOnInit() {

  //this.search = new LectionaryItemSearchModel();

  this.numberOfRecords = Number(localStorage.getItem(this.localStorageKey_numberOfRecords));
  if (this.numberOfRecords === 0) {
    this.numberOfRecords = 15;
  }

  this.searchProofed = this.GetDefaultOption_SearchProofed();
  this.searchStatus = this.GetDefaultOption_SearchStatus();

  console.clear();
  var id = this.route.snapshot.paramMap.get("id");
  console.log("ID:", id);
 
  if (id != null) { 
    this.editByDeepLink(Number(id));
  }  

}

private GetDefaultOption_SearchProofed() : boolean {
  var proofed = localStorage.getItem(this.localStorageKey_searchProofed);
  if (proofed === "false") {
    return false
  } else if (proofed === "true") {
    return true;
  }
  return null;
}

private GetDefaultOption_SearchStatus() : boolean {
  var proofed = localStorage.getItem(this.localStorageKey_searchStatus);
  if (proofed === "false") {
    return false
  } else if (proofed === "true") {
    return true;
  }
  return null;
}

private PrepareSearch(items: any[]): void {
 
  items.forEach(item => {
     
    var availableSearchTerms: string[] = []; 

    item.ItemAdjustedName = item.ItemName;

    if (item.LanguageStyle != undefined) {
      item.ItemAdjustedName += ", " + item.LanguageStyle;
    }

    // Set search terms for angular
    availableSearchTerms.push(item.ItemAdjustedName);
    availableSearchTerms.push(item.LectionaryItemType);
    availableSearchTerms.push(item.Source);
    availableSearchTerms.push(item.PageNumber); 

    item.AvailableSearchTerms = availableSearchTerms; 


  });

}

public add() {

  var modal = this.dialog.open(LectionaryItemEditComponent);
  modal.componentInstance.setModel(null);

  modal.afterClosed().subscribe((savedItem: LectionaryItem) => {

    console.log("modal closed", savedItem);
    if (savedItem !== undefined) { 
      this.search(this.mostRecentLectionaryItemSearchModel);
    }
 
  });

}


public edit(obj: LectionaryItemSummary) {

  var modal = this.dialog.open(LectionaryItemEditComponent);
  modal.componentInstance.setModel(obj.Id);

  modal.afterClosed().subscribe((savedItem: LectionaryItemSummary) => {

    console.log("modal closed", savedItem);

    if (savedItem !== undefined) { 
      this.updateItemList(savedItem); 
    }

  //  this.ref.markForCheck();

  });

}


public editByDeepLink(id: number) {

  var modal = this.dialog.open(LectionaryItemEditComponent);
  modal.componentInstance.setModel(id);

  modal.afterClosed().subscribe((savedItem: LectionaryItemSummary) => { 
  
    var channel = new BroadcastChannel("editItem");
    channel.postMessage("reload");
    
    window.close();
  });
}


public updateItemList(newItem: LectionaryItemSummary) {
  
  console.log("updateItemList", newItem);
    var results = this.entities.filter(s=> { return s.Id == newItem.Id });
    if (results.length > 0) { 

      var index = this.entities.indexOf(results[0]);
      this.entities[index] = newItem;
 
      this.PrepareSearch(this.entities);
      this.updateStats();
    } 

}

public changeProofedOption() {
  localStorage.setItem(this.localStorageKey_searchProofed, this.searchProofed + "");
}

public changeStatusOption() {
  localStorage.setItem(this.localStorageKey_searchStatus, this.searchStatus + "");
}


public changeNumberOfRecords() {
  localStorage.setItem(this.localStorageKey_numberOfRecords, this.numberOfRecords.toString());
}
 

private renderPaginationItemStatus(p: any) {
  //console.log("renderPaginationItemStatus", p, this.numberOfRecords ,p.getCurrent());
 
  var currentPage = p.getCurrent();
  var numberOfRecordsInSet = p.getTotalItems();

  var startingRecord = ((currentPage - 1) * this.numberOfRecords) + 1;

  if (currentPage == 1) {
    startingRecord = 1;
  }
   
  var endingRecord = startingRecord + (this.numberOfRecords - 1);
  if (endingRecord > numberOfRecordsInSet) {
    endingRecord = numberOfRecordsInSet;
  };
 
  return startingRecord + " to " + endingRecord; 
}


private defaultIfNull(object) {
  if (object && object.Localized) {
    return object.Localized[0].Name;
  } else {
    return null;
  }
}


public delete(obj: LectionaryItem) { 

   if (confirm("Are you sure you want to delete this Lectionary Item?")) {

    this.lectionaryItemSvc.delete(obj.Id).then(
      (data) => {  
        this.search(this.mostRecentLectionaryItemSearchModel);
        alert("Item successfully deleted"); 
      }
      ,(err) => {
        alert("There was an error while deleting this Lectionary Item: " + err);
      }
    );
   }

}

public search(e: LectionaryItemSearchModel) {
  console.log("search", e);
  this.mostRecentLectionaryItemSearchModel = e;
  this.getItems(e);
}

public getItems(model: LectionaryItemSearchModel) { 
  this.isLoading = true;
  this.lectionaryItemSvc.loadEntities(model).then(
    (data) => {
      this.PrepareSearch(data);
      this.entities = data;
      this.isLoading = false;

      this.updateStats();
    }
  );
}

private updateStats() { 
  this.countTotalNotProofed = this.entities.filter(s=> s.IsProofed === false).length;
  this.countTotalProofed = this.entities.filter(s=> s.IsProofed === true).length;
}

}

